import React, { Fragment } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import MoreIcon from '@mui/icons-material/MoreVert';
import Popover from '@mui/material/Popover';

const PREFIX = 'ColorPicker';

const classes = {
  menu: `${PREFIX}-menu`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(() => ({
  [`& .${classes.menu}`]: {
    width: 200,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
}));

const ColorPicker = props => {
  const { colors, currentColor, setCurrentColor = () => {} } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(undefined);
  };

  const open = Boolean(anchorEl);

  return (
    <Root style={{ display: 'inline-block' }}>
      <div
        style={{
          width: 20,
          height: 20,
          backgroundColor: currentColor,
          cursor: 'pointer',
          border: `1px solid #B7B7B7`,
          borderRadius: 10,
        }}
        onClick={handleMenuOpen}
      ></div>
      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{ paper: { sx: { width: 200, display: 'flex', flexWrap: 'wrap', justifyContent: 'center' } } }}
        onClose={handleMenuClose}
        onClick={handleMenuClose}
        open={open}
        anchorEl={anchorEl}
      >
        {colors.map(color => (
          <div
            key={color}
            style={{
              width: 20,
              height: 20,
              backgroundColor: color,
              cursor: 'pointer',
              border: `1px solid ${color === currentColor ? '#213955' : '#B7B7B7'}`,
              borderRadius: 10,
              margin: '5px 10px',
            }}
            onClick={() => setCurrentColor(color)}
          ></div>
        ))}
      </Popover>
    </Root>
  );
};

export default ColorPicker;
